import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");
const AdminWelcome: React.FC = () => {
  return (<>

    <div className="container-fluid  pt-3 d-flex align-items-center justify-content-center bg-light">
      <div className="row w-100 shadow rounded bg-white" style={{ maxWidth: "900px" }}>

        {/* Right Side - Login Form */}
        <div className="col-md-6 p-5 d-flex flex-column justify-content-center">
          <div className="text-center mb-4">
            <img src={tsmclogo} alt="Logo" style={{ width: "80px" }} height={40} className="me-2" />
            <h4 className="mt-2 cme-header">Welcome to Admin </h4>
          </div>
            
        </div>
      </div>
    </div>
  </>
  );
};

export default AdminWelcome;
